import { render } from "./act-access-modal.vue?vue&type=template&id=941c9e2c&ts=true"
import script from "./act-access-modal.ts?vue&type=script&lang=ts&external"
export * from "./act-access-modal.ts?vue&type=script&lang=ts&external"

import "./act-access-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__